<template>
    <div class="flex-1">
        <skeleton v-if="plan === undefined" />
        <not-found v-else-if="plan === null" />
        <purchase-gift-card
            v-else
            :plan="plan"
            :is-editing="false"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import PurchaseGiftCard from '~/components/PurchaseContract/GiftCard/PurchaseGiftCard.vue'
import { useQuery } from '@tanstack/vue-query'
import { useRpQuery } from '~/composables/graphql'
import { graphql } from '~/resources/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'
import Skeleton from 'primevue/skeleton'
import NotFound from '~/components/NotFound/NotFound.vue'

const props = defineProps<{ planId: string }>()
const planId = computed(() => props.planId)
const activeFacility = useActiveFacility()

const query = useRpQuery()
const { data } = useQuery({
    queryKey: ['GiftCardPurchaseQuery', planId, activeFacility],
    queryFn: () =>
        query(
            graphql(/* GraphQL */ `
                query GiftCardPurchaseQuery(
                    $planId: ID!
                    $facilityId: ID!
                    $input: SimpleSpokeInput
                ) {
                    plan(id: $planId) {
                        ...PurchaseGiftCardPlanFragment
                    }
                }
            `),
            {
                planId: planId.value,
                facilityId: activeFacility.value.id,
                input: {
                    facilityId: activeFacility.value.id
                }
            }
        )
})

const plan = computed(() => {
    if (data.value === undefined) {
        return undefined
    }

    if (data.value.plan === null) {
        return null
    }

    return data.value.plan
})
</script>
